import { render } from "./DelayAlert.vue?vue&type=template&id=131f8a52&scoped=true"
import script from "./DelayAlert.vue?vue&type=script&lang=js"
export * from "./DelayAlert.vue?vue&type=script&lang=js"

import "./DelayAlert.vue?vue&type=style&index=0&id=131f8a52&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131f8a52"]])

export default __exports__